import React from 'react';
import { getCuCode } from '../utils';
import { Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
const Header = () => {
    const { i18n } = useTranslation();
    const handleClick = () => {
        if (i18n.language === 'fr') i18n.changeLanguage('en');
        else i18n.changeLanguage('fr');
    };

    const cuCode = getCuCode();
    const logoUrl = cuCode ? `./cu-logos/${cuCode}.png` : './cu-logos/logo_technicost.png';
    return (
        <div
            className="flex items-center justify-center md:justify-start bg-white h-16 md:h-20 border-b"
            style={{ justifyContent: 'space-between' }}>
            <div>
                <img src={logoUrl} alt="logo" className="max-h-20 md:ml-10" />
            </div>

            <Button color="inherit" onClick={handleClick} style={{ marginRight: '2.5rem' }}>
                {i18n.language === 'fr' ? 'EN' : 'FR'}
            </Button>
        </div>
    );
};
export default Header;
